let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1vq4G"), load("2uoBF"), load("fDwDZ")]).then(() => parcelRequire('2I7c2'));